import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import AlertContext from '../../../GlobalComponents/Alert/contexts/alertContext';

//import global components
import { Card, Modal, ModalActionConfirm } from '../../../../imports';

//import services
import { ObtenerGradoAcademico, ObtenerGradoAcademicoSinCertificacion, EliminarEducacion, EditarEducacion, AgregarEducacionIndividual } from '../../../../servicios/ServicioEducacion';

//import icons from heroicons
import { AcademicCapIcon, PlusCircleIcon, InformationCircleIcon, XMarkIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

import { GlobalWorkerOptions } from 'pdfjs-dist';
import { PDFJS } from 'pdfjs-dist';

export default function Educacion({
    validationMessages,
    userData,
    setUserData,
    finalData,
    setstateEducacion,
    stateInfoPersonal,
    setstateInfoPersonal,
    allowEdit,
    listEducationByPerson,
    setListEducationByPerson,
    educationDataEdit,
    setEducationDataEdit,
    isFirstLoadEducation,
    setIsFirstLoadEducation,
    idCurriculum
}) {

    //use alert context
    const alertCtx = useContext(AlertContext);

    //here we pass a default input property to save in userData
    //all inputs use this same event in 'onchange'
    const handleChange = (e) => {
        const { name, value } = e.target;
        setValue(name, e.target.value)
    };

    //use react hook form to get values and make validations
    const { register, reset, getValues, setValue, handleSubmit, formState } = useForm({
        mode: 'all',
        defaultValues: {
            nameTitle: '',
            institution: '',
            educationLevel: '',
            fileInput: '',
            startDate: '',
            finishDate: '',
            inCourse: '',
            endDate: '',
        }
    });

    const modalStyle = {
        background: 'transparent',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        margin: 0
    };

    const { errors } = formState;

    //States
    const [validations, setValidations] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [actionTypeConfirmModal, setActionTypeConfirmModal] = useState("");
    const [showConfirmEditModal, setShowConfirmEditModal] = useState(false);
    const [showCertificate, setshowCertificate] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [educationOptions, setEducationOptions] = useState([]);
    const [educationOptionsWithoutCertificate, setEducationOptionsWithoutCertificate] = useState([]);
    const [educationGrade, setEducationGrade] = useState('');
    const [Gradename, setGradeName] = useState('');
    const [idFromCard, setIdFromCard] = useState(0);
    const [userSaveActionSuccess, setUserSaveActionSuccess] = useState(false);
    const [dataIndividualEducation, setDataIndividualEducation] = useState({});
    const [detectCheckBox, setDetect] = useState(false);
    const [InCourse, setCourse] = useState(false);
    const [listEducation, setListEducation] = useState([]);
    const [currentIdCard, setCurrentIdCard] = useState(null);
    const [fileName, setFileName] = useState('');
    const [filePath, setFilePath] = useState('');
    const [fileExtension, setFileExtension] = useState('');
    const [pdf, setPdf] = React.useState("");

    //validate if user already complete cv
    const userCompleteCV = sessionStorage.getItem("USER_COMPLETE_CV");

    //asing this property to work with pdf
    GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.js`;

    //call services to delete elements from education
    async function EliminarEducacionPersona(idEducacion) {
        const response = await EliminarEducacion(idEducacion);
        return response;
    }

    //function to save 'educacion' in list
    async function getEducationType() {
        const response = await ObtenerGradoAcademico();
        if (response !== undefined) {
            setEducationOptions(response);
        }
    }

    //function to save 'educacion opciones' in list
    async function getEducationTypeWithoutCertifications() {
        const response = await ObtenerGradoAcademicoSinCertificacion();
        if (response !== undefined) {
            setEducationOptionsWithoutCertificate(response);
        }
    }

    //method to add new education
    const AgregarEducacionPersona = async (e) => {
        const EducacionData = {
            nombreTitulo: dataIndividualEducation.dataForGlobalList?.nameTitle,
            institucion: dataIndividualEducation.dataForGlobalList?.institution,
            fechaInicio: dataIndividualEducation.dataForGlobalList?.startDate === "" ? null : dataIndividualEducation.dataForGlobalList?.startDate,
            fechafinalizacion: dataIndividualEducation.dataForGlobalList?.finishDate === "" ? null : dataIndividualEducation.dataForGlobalList?.finishDate,
            cursando: dataIndividualEducation.dataForGlobalList?.inCourse,
            imgTitulo: dataIndividualEducation.dataForGlobalList?.filePathValue,
            idGrado: parseInt(dataIndividualEducation.dataForGlobalList?.educationLevel, 10),
            idPersona: idCurriculum,
            imgNombre: dataIndividualEducation.dataForGlobalList?.fileNameValue,
            extension: dataIndividualEducation.dataForGlobalList.fileExtensionValue,
        }

        const educacionResponse = await AgregarEducacionIndividual(EducacionData);

        if (educacionResponse.indicador === 0) {
            if (currentIdCard) {
                if (listEducation?.length > currentIdCard - 1 && listEducation[currentIdCard] !== undefined) {
                    for (let item of Object.keys(listEducation)) {
                        if (listEducation[item] === listEducation[currentIdCard]) {
                            listEducation[item] = dataIndividualEducation
                        }
                    }
                }
            } else {
                setListEducation([...listEducation, dataIndividualEducation])
            }

            alertCtx.success(educacionResponse.mensaje);
            setUserSaveActionSuccess(true)
            setShowConfirmSaveModal(false)
            setDetect(false)
            setDataIndividualEducation({})
            setCurrentIdCard(null);
            setShowModal(false);
        }
    }

    //method to edit education from person by id
    const EditarEducacionPersona = async (e) => {
        const EducacionData = {
            idEducacion: dataIndividualEducation.dataForGlobalList?.idEducation,
            nombreTitulo: dataIndividualEducation.dataForGlobalList?.nameTitle,
            institucion: dataIndividualEducation.dataForGlobalList?.institution,
            fechaInicio: dataIndividualEducation.dataForGlobalList?.startDate === "" ? null : dataIndividualEducation.dataForGlobalList?.startDate,
            fechafinalizacion: dataIndividualEducation.dataForGlobalList?.finishDate === "" ? null : dataIndividualEducation.dataForGlobalList?.finishDate,
            cursando: dataIndividualEducation.dataForGlobalList?.inCourse,
            imgTitulo: dataIndividualEducation.dataForGlobalList?.filePathValue,
            idGrado: parseInt(dataIndividualEducation.dataForGlobalList?.educationLevel, 10),
            idPersona: idCurriculum,
            imgNombre: dataIndividualEducation.dataForGlobalList?.fileNameValue,
            extension: dataIndividualEducation.dataForGlobalList?.fileExtensionValue,
        }

        const educacionResponse = await EditarEducacion(EducacionData);

        if (educacionResponse.indicador === 0) {
            if (currentIdCard) {
                if (listEducation?.length > currentIdCard - 1 && listEducation[currentIdCard] !== undefined) {
                    for (let item of Object.keys(listEducation)) {
                        if (listEducation[item] === listEducation[currentIdCard]) {
                            listEducation[item] = dataIndividualEducation
                        }
                    }
                }
            } else {
                setListEducation([...listEducation, dataIndividualEducation])
            }

            alertCtx.success(educacionResponse.mensaje);
            setUserSaveActionSuccess(true)
            setShowConfirmEditModal(false)
            setDetect(false)
            setDataIndividualEducation({})
            setCurrentIdCard(null);
            setShowModal(false);
        }
    }

    const certificacion = (e) => {
        e.preventDefault();
        const selectedText = e.target.options[e.target.selectedIndex].text;
        setGradeName(selectedText);
        const certificacion = (e.target.value);

        if (certificacion == 9) {
            setshowCertificate(true)
            resetAllDates()
        } else {
            setshowCertificate(false)
        }
    }

    //use to change and detect checkbox
    const detectCheck = event => {
        event.preventDefault();
        const newValue = !InCourse;
        setCourse(newValue);
        setDetect(newValue);
        setValue("inCourse", newValue);
        if (newValue === false) {
            resetinputs();
        }
    }

    //function to save 'education' in list
    const SaveEducationOptions = () => {
        const startDate = getValues("startDate");
        const finishDate = getValues("finishDate");
        const nameTitle = getValues("nameTitle");
        const institution = getValues("institution");
        const educationLevel = getValues("educationLevel");

        // Validar campos requeridos manualmente
        if (!nameTitle || !institution || !educationLevel) {
            alertCtx.error("Por favor complete todos los campos requeridos");
            return;
        }

        // Validar fechas solo si NO está en curso y NO es certificado
        if (startDate === "" && finishDate === "" && showCertificate === false && InCourse === false) {
            alertCtx.error("Por favor ingrese las fechas");
            return;
        } else if (startDate > finishDate && InCourse === false && finishDate !== "") {
            alertCtx.error("La fecha de finalización debe ser mayor a la fecha de inicio");
            return;
        } else {
            const nameTitle = getValues("nameTitle");
            const institution = getValues("institution");
            const educationLevel = getValues("educationLevel");
            const startDate = getValues("startDate");
            const inCourse = InCourse;
            const finishDate = InCourse === true ? "" : getValues("finishDate");
            const fileNameValue = fileName;
            const filePathValue = filePath;
            const grade = Gradename;
            const fileExtensionValue = fileExtension;

            const dataForGlobalList = {
                nameTitle: nameTitle,
                institution: institution,
                educationLevel: parseInt(educationLevel, 10),
                startDate: startDate,
                finishDate: finishDate,
                inCourse: inCourse,
                fileInput: filePath,
                fileNameValue: fileNameValue,
                filePathValue: filePathValue,
                idEducation: idFromCard,
                grade: grade,
                fileExtensionValue: fileExtensionValue,
            }

            const object = {
                "dataHeader": {
                    "Titulo": nameTitle,
                    "NivelEducacion": grade,

                },
                "dataBody": {
                    "Institucion": institution,
                    "FechaInicio": startDate,
                },
                "dataFooter": {
                    "Cursando": inCourse ? "Si" : "No"
                },
                "dataID": {
                    "idEducacion": idFromCard
                },
                "dataForGlobalList": dataForGlobalList
            }

            if (userCompleteCV === "true") {
                setDataIndividualEducation(object);
                if (actionTypeConfirmModal === "Agregar") setShowConfirmSaveModal(true);
                if (actionTypeConfirmModal === "Editar") setShowConfirmEditModal(true);
                resetAllInputs();
            } else {
                if (currentIdCard) {
                    if (listEducation?.length > currentIdCard - 1 && listEducation[currentIdCard] !== undefined) {
                        for (let item of Object.keys(listEducation)) {
                            if (listEducation[item] === listEducation[currentIdCard]) {
                                listEducation[item] = object
                            }
                        }
                    }
                } else {
                    setListEducation([...listEducation, object])
                }
                resetAllInputs();
                setCurrentIdCard(null);
                setShowModal(false);
                alertCtx.success("Datos guardados temporalmente");
                setSelectedFile("");
                setIdFromCard(0);
            }
        }
    }

    const resetAllInputs = () => {
        reset({
            nameTitle: "",
            institution: "",
            educationLevel: "",
            fileInput: "",
            startDate: "",
            finishDate: "",
            inCourse: false,
            endDate: "",
        }, {
            keepErrors: false,
            keepDirty: false,
        })
        setshowCertificate(false);
        setCourse(false)
        setSelectedFile("");
        setEducationGrade("");
        setFileName("");
        setFilePath("");
        setFileExtension("");
        setDetect(false);
    }

    const resetAllDates = () => {
        reset({
            startDate: "",
            finishDate: "",
        }, {
            keepErrors: false,
            keepDirty: false,
        })
    }

    const resetinputs = () => {
        setValue("finishDate", "");
        setValue("fileInput", "");
        setSelectedFile("");
        setFileName("");
        setFilePath("");
    }

    function setValuesById(list) {
        if (!list || !list.dataForGlobalList) return;

        setValue("nameTitle", list.dataForGlobalList?.nameTitle || "")
        setValue("institution", list.dataForGlobalList?.institution || "")
        setValue("educationLevel", list.dataForGlobalList?.educationLevel || "")
        setEducationGrade(list.dataForGlobalList?.grade || "")
        setValue("fileInput", list.dataForGlobalList?.filePathValue || "")
        setValue("startDate", list.dataForGlobalList?.startDate || "")
        setValue("finishDate", list.dataForGlobalList?.finishDate || "")
        setValue("inCourse", list.dataForGlobalList?.inCourse || false)

        const inCourseValue = list.dataForGlobalList?.inCourse === true || list.dataForGlobalList?.inCourse === "true";

        setDetect(inCourseValue);
        setFileName(list.dataForGlobalList?.fileNameValue || "");
        setFilePath(list.dataForGlobalList?.filePathValue || "");
        setSelectedFile(list.dataForGlobalList?.fileNameValue || "");
        setCourse(inCourseValue);
        setFileExtension(list.dataForGlobalList?.fileExtensionValue || "");

        if (list.dataForGlobalList?.educationLevel === 9) setshowCertificate(true);
        setIdFromCard(list?.dataID?.idEducacion);
    }

    function setValuesByIdListPerson(list) {
        const startMonth = new Date(list?.fechaInicio).getMonth() + 1;
        const startYear = new Date(list?.fechaInicio).getFullYear();
        const startDay = new Date(list?.fechaInicio).getDate();
        const startDateFormatted = `${startYear}-${startMonth}-${startDay}`;
        const startDate = new Date(startDateFormatted)

        const endMonth = new Date(list?.fechaFin).getMonth() + 1;
        const endYear = new Date(list?.fechaFin).getFullYear();
        const endDay = new Date(list?.fechaFin).getDate();
        const endDateFormatted = `${endYear}-${endMonth}-${endDay}`;
        const endDate = new Date(endDateFormatted)

        setValue("nameTitle", list?.nombreTitulo)
        setValue("institution", list?.institucion)
        setValue("educationLevel", list?.educationLevel)
        setValue("fileInput", list?.imgTitulo)
        setValue("startDate", startDate.toLocaleDateString('fr-CA'))
        setValue("finishDate", endDate.toLocaleDateString('fr-CA'))
        setValue("inCourse", list?.cursando)
        setEducationGrade(list?.grado)
        setFileName(list?.imgNombre)
        setFilePath(list?.imgTitulo)
        setSelectedFile(list?.imgNombre)
        setCourse(list?.cursando)
        setIdFromCard(list?.idEducacion);
        setFileExtension(list?.extension);
    }

    async function showPdf(blob) {
        try {
            var _PDF_DOC = await PDFJS.getDocument({ url: blob });
            setPdf(_PDF_DOC);
        } catch (error) {
            console.log(error.message);
        }
    }

    const selectFile = (event) => {
        event.preventDefault();

        const userfile = event.target.files[0];
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];

        if (userfile.type === 'application/pdf') {
            setValue("fileInput", userfile.name)
            setFileName(userfile.name)
            setSelectedFile(userfile.name);
            setFileExtension(userfile.type);

            const reader = new FileReader();
            reader.onload = () => {
                const base64String = reader.result.split(",")[1];
                setFilePath(base64String);
            };
            reader.readAsDataURL(userfile);
        } else {
            if (userfile && validTypes.includes(userfile.type)) {
                setValue("fileInput", userfile.name)
                setFileName(userfile.name)
                setSelectedFile(userfile.name);
                setFileExtension(userfile.type);
                const reader = new FileReader();
                reader.onload = () => {
                    const base64String = reader.result.split(",")[1];
                    setFilePath(base64String);
                };
                reader.readAsDataURL(userfile);
            } else {
                alertCtx.error("¡Solo se aceptan imagenes o pdf!");
            }
        }
    }

    //create custom object with list by person id to render cards
    const customObjectByPersonList = useCallback(() => {
        listEducationByPerson.map((item) => {
            const startMonth = new Date(item?.fechaInicio).getMonth() + 1;
            const startYear = new Date(item?.fechaInicio).getFullYear();
            const startDay = new Date(item?.fechaInicio).getDay();
            const startDateFormatted = `${startYear}-${startMonth}-${startDay}`;
            const startDate = new Date(startDateFormatted)

            const endMonth = new Date(item?.fechaFin).getMonth() + 1;
            const endYear = new Date(item?.fechaFin).getFullYear();
            const endDay = new Date(item?.fechaFin).getDay();
            const endDateFormatted = `${endYear}-${endMonth}-${endDay}`;
            const endDate = new Date(endDateFormatted);

            const dataForGlobalList = {
                nameTitle: item?.nombreTitulo,
                institution: item?.institucion,
                educationLevel: item?.idGrado,
                startDate: item?.fechaInicio ? startDate.toLocaleDateString('fr-CA') : "",
                finishDate: item?.fechaFin ? endDate.toLocaleDateString('fr-CA') : "",
                inCourse: item?.cursando ? true : false,
                fileInput: item?.imgTitulo,
                fileNameValue: item?.imgNombre,
                filePathValue: item?.imgTitulo,
                grade: item?.grado,
                fileExtensionValue: item?.extension,
            }

            const object = {
                "dataHeader": {
                    "Titulo": item?.nombreTitulo,
                    "Nivel Educacion": item?.grado,
                },
                "dataBody": {
                    "Institucion": item?.institucion,
                    "Fecha Inicio": item?.fechaInicio ? startDate.toLocaleDateString('fr-CA') : "",
                    "Fecha Finalizacion": item?.fechaFin ? endDate.toLocaleDateString('fr-CA') : "",
                },
                "dataFooter": {
                    "Cursando": item?.cursando ? "Si" : "No"
                },
                "dataID": {
                    "idEducacion": item?.idEducacion
                },
                "dataForGlobalList": dataForGlobalList
            }

            if (listEducation !== undefined) {
                listEducation.push(object);
            }
        })
    }, [listEducationByPerson, listEducation])

    async function renderPage() {
        const canvas = document.createElement("canvas");
        canvas.setAttribute("className", "canv");

        var page = await pdf.getPage(1);

        var width = '800';
        var height = '550';

        canvas.height = height;
        canvas.width = width;

        var unscaledViewport = page.getViewport(1);
        var scale = Math.min((canvas.height / unscaledViewport.height), (canvas.width / unscaledViewport.width));
        var viewport = page.getViewport(scale);

        var render_context = {
            canvasContext: canvas.getContext("2d"),
            viewport: viewport,
        };

        await page.render(render_context).promise;
        let img = canvas.toDataURL("image/png");
        setFilePath(img.split(",")[1]);
        setFileExtension("image/png");
    }

    //useEffects
    useState(() => {
        getEducationType();
        getEducationTypeWithoutCertifications();
        setValidations(validationMessages);
    }, [])

    useEffect(() => {
        pdf && renderPage();
    }, [pdf])

    useEffect(() => {
        //validate for candidate view or admin view
        if (userCompleteCV === "true" && isFirstLoadEducation || allowEdit === true && isFirstLoadEducation) {
            if (listEducationByPerson?.length > 0) {
                customObjectByPersonList();
                if (isFirstLoadEducation) setIsFirstLoadEducation(false)
            }
        }

        if (userCompleteCV === "true" || allowEdit === true) {
            if (listEducation?.length > 0) {
                if (educationDataEdit) {
                    setEducationDataEdit(listEducation);
                }
            } else {
                if (educationDataEdit) {
                    setListEducation(educationDataEdit);
                }
            }
        } else {
            if (listEducation?.length > 0) {
                setstateEducacion(true);
                if (userData) {
                    setUserData({ ...userData, "listEducation": listEducation })
                }
            } else {
                setstateEducacion(false);
                if (userData["listEducation"]) {
                    setListEducation(userData["listEducation"])
                }
            }
        }

        if (userCompleteCV === "true" && !showModal || allowEdit === true && !showModal) {
            const timeout = setTimeout(() => {
                if (educationDataEdit) {
                    setEducationDataEdit(listEducation);
                }
            }, 1000);
            return () => clearTimeout(timeout);
        } else if (!showModal) {
            const timeout = setTimeout(() => {
                if (listEducation) {
                    if (userData) {
                        setUserData({ ...userData, "listEducation": listEducation });
                    }
                }
            }, 1000);
            return () => clearTimeout(timeout);
        }

        return (() => {
            if (userCompleteCV === "true" || allowEdit === true) {
                if (isFirstLoadEducation) {
                    setIsFirstLoadEducation(false);
                }
                if (educationDataEdit) {
                    setEducationDataEdit(listEducation);
                }
            } else {
                if (listEducation) {
                    setUserData({ ...userData, "listEducation": listEducation })
                }
            }
            setShowModal(false);
        })
    }, [showModal, listEducation, userSaveActionSuccess, dataIndividualEducation, actionTypeConfirmModal])

    return (
        <div className="w-full flex flex-col md:flex-row items-center justify-center px-1 mx-auto lg:py-0">
            <div className={userCompleteCV === "false" ? "w-full pt-1 bg-white rounded-lg shadow" : "w-full pt-1"}>
                <div className="relative container mx-auto items-center justify-center">
                    {listEducation?.length === 0 && userCompleteCV === "true" && !allowEdit && (
                        <div className="flex justify-center items-center mb-4 px-2 space-x-2">
                            <div className="flex-shrink-0">
                                <InformationCircleIcon className="h-8 w-8 mr-2 text-red-RS" />
                            </div>
                            <div>
                                <h1 className="font-bold font-base">Esta información es requerida para tomar en cuenta su Curriculum Vitae</h1>
                            </div>
                        </div>
                    )}

                    {!allowEdit && listEducation?.length === 0 && (
                        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                            <h1 className="text-decoration-line: underline">Por favor, presione Agregar para completar el apartado de educación</h1>
                        </div>
                    )}

                    {/* ADMINISTRADOR - Usar el mismo estilo de Card que el usuario */}
                    {allowEdit && listEducation?.length > 0 && (
                        <div className="container flex flex-wrap w-full py-4 mt-0 mx-auto items-start justify-center">
                            {listEducation?.map((item, index) => (
                                <div className="w-full m-0 mt-2 p-1 py-6 md:w-96" key={index}>
                                    <Card
                                        id={index}
                                        data={item}
                                        list={listEducation}
                                        setList={setListEducation}
                                        setCurrentIdCard={setCurrentIdCard}
                                        setShowModal={setShowModal}
                                        setValuesById={setValuesById}
                                        setValuesByIdListPerson={setValuesByIdListPerson}
                                        allowEdit={allowEdit}
                                        listByPerson={listEducationByPerson}
                                        setListEducationByPerson={setListEducationByPerson}
                                        userCompleteCV={userCompleteCV}
                                        deleteElementCV={EliminarEducacionPersona}
                                        setActionTypeConfirmModal={setActionTypeConfirmModal}
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                    {/* USUARIO - Mostrar tarjetas con opciones de edición */}
                    {!allowEdit && listEducation?.length > 0 && (
                        <div className="container flex flex-wrap w-full py-4 mt-6 mx-auto items-start justify-center">
                            {listEducation?.map((item, index) => (
                                <div className="w-full m-1 mt-8 p-1 py-6 md:w-96" key={index}>
                                    <Card
                                        id={index}
                                        data={item}
                                        list={listEducation}
                                        setList={setListEducation}
                                        setCurrentIdCard={setCurrentIdCard}
                                        setShowModal={setShowModal}
                                        setValuesById={setValuesById}
                                        setValuesByIdListPerson={setValuesByIdListPerson}
                                        allowEdit={allowEdit}
                                        listByPerson={listEducationByPerson}
                                        setListEducationByPerson={setListEducationByPerson}
                                        userCompleteCV={userCompleteCV}
                                        deleteElementCV={EliminarEducacionPersona}
                                        setActionTypeConfirmModal={setActionTypeConfirmModal}
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                    {/* BOTÓN AGREGAR - Solo visible en modo usuario (no admin) */}
                    {!allowEdit && (
                        <div>
                            {listEducation?.length > 0 ? (
                                <div className="flex absolute top-0 right-0 md:justify-center items-center mb-8 px-2 py-6">
                                    <button
                                        className="bg-greenButton hover:bg-primary-700 text-white text-sm py-2 px-4 rounded inline-flex items-center"
                                        onClick={() => {
                                            resetAllInputs();
                                            setShowModal(true);
                                            setActionTypeConfirmModal("Agregar");
                                        }}
                                    >
                                        <span>Agregar</span>
                                        <PlusCircleIcon className="w-8 h-8 ml-2"></PlusCircleIcon>
                                    </button>
                                </div>
                            ) : (
                                <div className="flex justify-center items-center mb-4 px-2 py-2">
                                    <button
                                        className="bg-greenButton hover:bg-primary-700 text-white text-sm py-2 px-4 rounded inline-flex items-center"
                                        onClick={() => {
                                            resetAllInputs();
                                            setShowModal(true);
                                            setActionTypeConfirmModal("Agregar");
                                        }}
                                    >
                                        <span>Agregar</span>
                                        <PlusCircleIcon className="w-8 h-8 ml-2"></PlusCircleIcon>
                                    </button>
                                </div>
                            )}
                        </div>
                    )}

                    {/* MODALES DE CONFIRMACIÓN */}
                    <Modal isVisible={showConfirmSaveModal} onClose={() => { setShowConfirmSaveModal(false) }} handleSubmit={() => null} onSaveOptions={null} showFotter={false} showCloseIcon={false}>
                        <ModalActionConfirm onSaveAction={AgregarEducacionPersona} actionType={actionTypeConfirmModal} setshowConfirmModal={setShowConfirmSaveModal} />
                    </Modal>

                    <Modal isVisible={showConfirmEditModal} onClose={() => { setShowConfirmEditModal(false) }} handleSubmit={() => null} onSaveOptions={null} showFotter={false} showCloseIcon={false}>
                        <ModalActionConfirm onSaveAction={EditarEducacionPersona} actionType={actionTypeConfirmModal} setshowConfirmModal={setShowConfirmEditModal} />
                    </Modal>

                    {/* MODAL DE EDUCACIÓN - Solo visible en modo usuario */}
                    {!allowEdit && (
                        <Modal
                            isVisible={showModal}
                            onClose={() => { setShowModal(false); resetAllInputs(); }}
                            onSaveOptions={SaveEducationOptions}
                            showFotter={false}
                            showCloseIcon={false}
                            insideContainer={{ className: "bg-transparent", style: modalStyle }}
                        >
                            <div className="bg-white rounded-3xl p-8 border border-gray-200/80 shadow-xl shadow-gray-200/30 w-full max-w-4xl mx-auto">
                                {/* Cabecera del modal */}
                                <div className="flex justify-between items-center mb-8 pb-4 relative">
                                    <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-[#B93C2F] via-[#D37267] to-transparent"></div>
                                    <div className="absolute bottom-0 left-0 w-1/3 h-1 bg-[#B93C2F] blur-sm opacity-50"></div>

                                    <div className="flex items-center gap-3">
                                        <div className="relative">
                                            <div className="absolute -inset-2 bg-gradient-to-r from-[#B93C2F] to-[#D37267] rounded-2xl opacity-20 blur-sm"></div>
                                            <div className="absolute -inset-1 border-2 border-[#B93C2F]/20 rounded-2xl"></div>
                                            <div className="relative bg-[#FFE5E1] p-3 rounded-2xl text-[#B93C2F] shadow-lg shadow-red-500/20">
                                                <AcademicCapIcon className="h-7 w-7" />
                                            </div>
                                        </div>
                                        <div className="relative">
                                            <h2 className="text-2xl font-extrabold text-[#3C2E2C] tracking-tight">Educación</h2>
                                            <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-[#B93C2F] to-transparent"></div>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => { setShowModal(false); resetAllInputs(); }}
                                        className="p-2 rounded-xl hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-all duration-300 hover:rotate-90"
                                    >
                                        <XMarkIcon className="h-5 w-5" />
                                    </button>
                                </div>

                                <form onSubmit={(e) => { e.preventDefault(); SaveEducationOptions(); }} className="space-y-5">
                                    {/* Nombre del Título */}
                                    <div className="flex flex-col space-y-1.5">
                                        <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                            <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                            Nombre del título
                                        </label>
                                        <div className="relative group">
                                            <input
                                                type="text"
                                                name="nameTitle"
                                                {...register("nameTitle", { required: true, maxLength: 100 })}
                                                id="nameTitle"
                                                placeholder="Nombre del título"
                                                className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 hover:border-gray-300 pr-12"
                                            />
                                            <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-300 group-hover:text-[#B93C2F] transition-colors duration-300">
                                                <AcademicCapIcon className="h-5 w-5" />
                                            </div>
                                        </div>
                                        {validations.nameTitle?.map((values) => (
                                            errors.nameTitle?.type === values.type &&
                                            <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                        ))}
                                    </div>

                                    {/* Nivel de Educación e Institución en 2 columnas */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="flex flex-col space-y-1.5">
                                            <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                Nivel de Educación
                                            </label>
                                            <select
                                                id="educationLevel"
                                                {...register('educationLevel', { required: true })}
                                                onChange={certificacion}
                                                className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 appearance-none cursor-pointer hover:border-gray-300"
                                                name="educationLevel"
                                            >
                                                <option value="">--Seleccione tipo de educación--</option>
                                                {educationOptions.map((item, index) => (
                                                    <option key={index} value={item.idGrado}>{item.grado}</option>
                                                ))}
                                            </select>
                                            {validations.educationLevel?.map((values) => (
                                                errors.educationLevel?.type === values.type &&
                                                <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                            ))}
                                        </div>

                                        <div className="flex flex-col space-y-1.5">
                                            <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                Institución
                                            </label>
                                            <div className="relative group">
                                                <input
                                                    type="text"
                                                    name="institution"
                                                    {...register("institution", { required: true, maxLength: 100, pattern: /^[a-zA-ZñÑ\s\W]/ })}
                                                    id="institution"
                                                    placeholder="Institución"
                                                    className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 hover:border-gray-300 pr-12"
                                                />
                                                <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-300 group-hover:text-[#B93C2F] transition-colors duration-300">
                                                    <AcademicCapIcon className="h-5 w-5" />
                                                </div>
                                            </div>
                                            {validations.institution?.map((values) => (
                                                errors.institution?.type === values.type &&
                                                <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                            ))}
                                        </div>
                                    </div>

                                    {/* ¿En Curso? y Fechas en 2 columnas */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
                                        {!showCertificate && (
                                            <div className="flex flex-col space-y-2">
                                                <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                    <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                    ¿En Curso?
                                                </label>
                                                <div className="flex items-center space-x-6 h-[50px]">
                                                    <label className="flex items-center space-x-2 cursor-pointer group">
                                                        <div className="relative">
                                                            <input
                                                                type="radio"
                                                                name="InCourse"
                                                                value="true"
                                                                checked={detectCheckBox === true}
                                                                onChange={detectCheck}
                                                                className="sr-only"
                                                            />
                                                            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all duration-300 ${detectCheckBox === true
                                                                ? 'border-[#B93C2F] bg-[#B93C2F] shadow-lg shadow-red-500/30 scale-110'
                                                                : 'border-gray-300 bg-white group-hover:border-[#B93C2F] group-hover:scale-105'
                                                                }`}>
                                                                {detectCheckBox === true && (
                                                                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                                                    </svg>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <span className={`text-sm font-semibold transition-all duration-300 ${detectCheckBox === true ? 'text-[#B93C2F]' : 'text-gray-600 group-hover:text-gray-800'
                                                            }`}>Sí</span>
                                                    </label>

                                                    <label className="flex items-center space-x-2 cursor-pointer group">
                                                        <div className="relative">
                                                            <input
                                                                type="radio"
                                                                name="InCourse"
                                                                value="false"
                                                                checked={detectCheckBox === false}
                                                                onChange={detectCheck}
                                                                className="sr-only"
                                                            />
                                                            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all duration-300 ${detectCheckBox === false
                                                                ? 'border-[#B93C2F] bg-[#B93C2F] shadow-lg shadow-red-500/30 scale-110'
                                                                : 'border-gray-300 bg-white group-hover:border-[#B93C2F] group-hover:scale-105'
                                                                }`}>
                                                                {detectCheckBox === false && (
                                                                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                                                    </svg>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <span className={`text-sm font-semibold transition-all duration-300 ${detectCheckBox === false ? 'text-[#B93C2F]' : 'text-gray-600 group-hover:text-gray-800'
                                                            }`}>No</span>
                                                    </label>
                                                </div>
                                            </div>
                                        )}

                                        <div className="flex flex-col space-y-3">
                                            {!showCertificate && (
                                                <div className="flex flex-col space-y-1.5">
                                                    <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                        <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                        Fecha inicio
                                                    </label>
                                                    <input
                                                        type="date"
                                                        name="startDate"
                                                        {...register("startDate", { onChange: handleChange, required: !showCertificate })}
                                                        id="startDate"
                                                        className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 cursor-pointer hover:border-gray-300"
                                                    />
                                                    {validations.startDate?.map((values) => (
                                                        errors.startDate?.type === values.type &&
                                                        <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                                    ))}
                                                </div>
                                            )}

                                            {!showCertificate && InCourse === false && (
                                                <div className="flex flex-col space-y-1.5">
                                                    <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                        <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                        Fecha finalización
                                                    </label>
                                                    <input
                                                        type="date"
                                                        name="finishDate"
                                                        id="finishDate"
                                                        {...register("finishDate", { required: !showCertificate })}
                                                        className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 cursor-pointer hover:border-gray-300"
                                                    />
                                                    {validations.finishDate?.map((values) => (
                                                        errors.finishDate?.type === values.type &&
                                                        <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Adjuntar título */}
                                    {InCourse === false && (
                                        <div className="flex flex-col space-y-1.5">
                                            <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                Adjuntar título
                                            </label>
                                            <div className="relative">
                                                <input
                                                    type="file"
                                                    id="fileInput"
                                                    name="fileInput"
                                                    accept=".jpg,.jpeg,.png,.pdf"
                                                    onChange={selectFile}
                                                    className="w-full px-4 py-3 bg-white border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer transition-all duration-300 hover:border-[#B93C2F] hover:bg-red-50/30 group text-sm file:mr-4 file:py-1.5 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#FFE5E1] file:text-[#B93C2F] hover:file:bg-[#FFD6D0]"
                                                />
                                            </div>
                                            {validations.fileInput?.map((values) => (
                                                errors.fileInput?.type === values.type &&
                                                <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                            ))}
                                        </div>
                                    )}

                                    {InCourse === false && selectedFile && (
                                        <div className="flex flex-col space-y-1.5">
                                            <span className="text-sm text-gray-500">
                                                Archivo seleccionado: <span className="font-medium text-[#3C2E2C]">{selectedFile}</span>
                                            </span>
                                        </div>
                                    )}

                                    {/* Separador */}
                                    <div className="relative my-6">
                                        <div className="absolute inset-0 flex items-center">
                                            <div className="w-full border-t-2 border-gray-200/60"></div>
                                        </div>
                                        <div className="relative flex justify-center">
                                            <span className="px-4 bg-white">
                                                <span className="flex items-center gap-2 text-xs text-gray-400 font-mono">
                                                    <span className="w-4 h-0.5 bg-gradient-to-r from-[#B93C2F] to-[#D37267]"></span>
                                                    ◆
                                                    <span className="w-4 h-0.5 bg-gradient-to-l from-[#B93C2F] to-[#D37267]"></span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>

                                    {/* Botones */}
                                    <div className="flex justify-end gap-4 pt-2">
                                        <button
                                            type="button"
                                            onClick={() => { setShowModal(false); resetAllInputs(); }}
                                            className="px-8 py-3 bg-white border-2 border-gray-200 rounded-2xl text-sm font-bold text-[#D37267] hover:bg-red-50 hover:border-[#D37267] transition-all duration-300 shadow-sm hover:shadow-md"
                                        >
                                            Cancelar
                                        </button>

                                        <button
                                            type="submit"
                                            className="px-8 py-3 bg-[#006E4E] hover:bg-[#005c41] text-white rounded-2xl text-sm font-bold flex items-center gap-2 transition-all duration-300 shadow-lg shadow-emerald-800/20 hover:shadow-emerald-800/30"
                                        >
                                            <CheckCircleIcon className="h-5 w-5" />
                                            Confirmar
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </Modal>
                    )}
                </div>
            </div>
        </div>
    );
}